<template>
  <b-modal
    modal-class="listing-media-archive-modal"
    :visible="visible"
    :no-fade="true"
    :hide-footer="true"
    title="Download Listing Media"
    @hide="hide()"
    @shown="onShown()"
  >
    <div
      v-if="!archive.result"
      class="py-5 h1 text-center"
    >
      <i class="fa fa-fw fa-circle-o-notch fa-spin"></i>
    </div>
    <div
      v-if="'notification' === archive.result"
    >
      <p>
        We're downloading the media for this listing now,
        and when the zip file is ready, we'll email you at
        <b>{{ archive.to.email }}</b>.
      </p>
      <hr>
      <button
        class="btn btn-outline-dark ml-1"
        @click.prevent="hide()"
      >
        Close
      </button>
    </div>
    <div
      v-if="'download' === archive.result"
    >
      <p>
        Your file is now ready. Click <b>Download</b>
        below to begin the download.
      </p>
      <hr>
      <a
        :href="archive.url"
        class="btn btn-primary"
      >
        <i class="fa fa-download mr-1"></i>
        Download
      </a>
      <button
        class="btn btn-outline-dark ml-1"
        @click.prevent="hide()"
      >
        Close
      </button>
    </div>
  </b-modal>
</template>

<script>
import $ from 'jquery'
import { getListingMediaArchive } from '@/api'

const $window = $(window)

const nullArchiveResponse = {
  result: null,
  url: null,
  to: {
    email: null
  }
}

export default {
  data () {
    return {
      visible: false,
      mlsConnection: null,
      mlsId: null,
      archive: Object.assign({}, nullArchiveResponse)
    }
  },
  mounted () {
    $window.on('listingMediaArchive.requested', (e, options) => {
      this.mlsConnection = options.mlsConnection
      this.mlsId = options.mlsId
      this.show()
    })
  },
  methods: {
    async show() {
      this.archive = Object.assign({}, nullArchiveResponse)
      this.visible = true
      try {
        const response = await getListingMediaArchive(this.mlsConnection, this.mlsId)
        this.archive = response.data
      } catch (error) {
        //
      }
    },
    hide() {
      this.visible = false
      return true
    },
    onShown() {
      //
    }
  }
}
</script>
